import { render, staticRenderFns } from "./campaignBudget.vue?vue&type=template&id=475cf44c&scoped=true"
import script from "./campaignBudget.vue?vue&type=script&lang=js"
export * from "./campaignBudget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475cf44c",
  null
  
)

export default component.exports